import {Paper, alpha, styled} from '@mui/material';
import {NavLink} from 'react-router-dom';

export const StyledPaper = styled(Paper)`
	position: fixed;
	z-index: 3;
	bottom: 0;
	left: 0;
	right: 0;
	box-shadow:
		0px 1px 8px 0px rgba(0, 0, 0, 0.12),
		0px 3px 4px 0px rgba(0, 0, 0, 0.14),
		0px 3px 3px -2px rgba(0, 0, 0, 0.2);
`;

export const StyledNavLink = styled(NavLink)`
	justify-content: center;
	display: flex;
	min-width: inherit;

	&:is(:focus, :active),
	&.active {
		background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.08)};
		color: ${({theme}) => theme.palette.primary.main};

		.MuiBottomNavigationAction-label {
			font-size: 0.875rem;
		}
	}

	& .MuiBottomNavigationAction-label {
		${({theme}) => theme.breakpoints.down(375)} {
			display: none;
		}
	}

	& .MuiTouchRipple-root .MuiTouchRipple-child {
		background-color: ${({theme}) => theme.palette.primary.main};
	}
`;

export const StyledModalButton = styled('div')`
	justify-content: center;
	display: flex;
	min-width: inherit;

	&:is(:hover) {
		background-color: ${({theme}) => alpha(theme.palette.primary.main, 0.08)};
		color: ${({theme}) => theme.palette.primary.main};

		.MuiBottomNavigationAction-label {
			font-size: 0.875rem;
		}
	}

	& .MuiBottomNavigationAction-label {
		${({theme}) => theme.breakpoints.down(375)} {
			display: none;
		}
	}

	& .MuiTouchRipple-root .MuiTouchRipple-child {
		background-color: ${({theme}) => theme.palette.primary.main};
	}
`;
